
import { FC } from "react";
import { Navigate, useParams } from "react-router-dom";


const SpeciesHomeRedirect: FC = () => {
    const params = useParams();

    if (params.species) {
        return <Navigate replace to={`/${params.species}`} />
    }

    return <Navigate replace to={`/error/404`} />
}

export default SpeciesHomeRedirect;